export const routes = (parentName) => {
  return [
    {
      path: "withdraws",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Withdraws`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "gateway",
          name: `${parentName}-Withdraws-Gateway`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Withdraws-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Withdraws-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Withdraws-Edit",
          component: () => import("./Edit.vue"),
        },
      ],
    },
  ];
};
